import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { buildPortColumns } from './columns';
import { getPortFields } from './fields';
import { getPortSimpleFilters } from './simpleFilters';

/**
 * Port QueryEntity - bundles columns and fields
 */
export const portEntity: QueryEntity<unknown> = {
  primaryLabel: { actual: 'Port' },
  buildColumns:
    buildPortColumns as () => import('@/components/table/types').Columns<unknown>,
  getFields: getPortFields,
  getSimpleFilters: getPortSimpleFilters,
};
